export default __webpack_public_path__ + "static/media/durvis-12-min.75c2c5de.jpg";